import * as actionTypes from '../../actions/actionTypes';

const initialState = {
    practiceRequests: [],
    loadingPracticeRequests: false,

    enterprises: [],
    loadingEnterprises: false,

    sendingPracticeRequest: false,
    errorOnSendPracticeRequest: false,

    updatingPracticeRequest: false,
    errorOnUpdatePracticeRequest: false
};

////////////////////////////////////////////////////////////////

const loadPracticeRequests = (state) => {
    return {
        ...state,
        loadingPracticeRequests: true
    }
}

const setPracticeRequests = ( state, action ) => {
    let tmp = [...action.practiceRequests]
    return {
        ...state,
        practiceRequests: tmp,
        loadingPracticeRequests: false
    }
};

////////////////////////////////////////////////////////////////

const loadEnterprises = (state) => {
    return {
        ...state,
        loadingEnterprises: true
    }
}

const setEnterprises = ( state, action ) => {
    let tmp = [...action.enterprises]
    return {
        ...state,
        enterprises: tmp,
        loadingEnterprises: false
    }
};

////////////////////////////////////////////////////////////////

const sendPracticeRequest = (state) => {
    return {
        ...state,
        sendingPracticeRequest: true
    }
}

const receivePracticeRequestResultOnSuccess = (state, action) => {
    let requests = state.practiceRequests;
    requests.unshift(action.newPracticeRequest);

    return {
        ...state,
        sendingPracticeRequest: false,
        practiceRequests: requests,
        errorOnSendPracticeRequest: false
    }
}

const receivePracticeRequestResultOnError = (state) => {
    return {
        ...state,
        sendingPracticeRequest: false,
        errorOnSendPracticeRequest: true
    }
}

////////////////////////////////////////////////////////////////

const updatePracticeRequest = (state) => {
    return {
        ...state,
        sendingPracticeRequest: true
    }
}

const receiveUpdatedPracticeRequestOnSuccess = (state, action) => {
    let requests = state.practiceRequests;
    let request = action.practiceRequest;
    for (let i = 0; i < requests.length; i++) {
        if (requests[i].id === request.id) {
            requests[i] = request;
            break;
        }
    }

    return {
        ...state,
        sendingPracticeRequest: false,
        practiceRequests: requests,
        errorOnSendPracticeRequest: false
    }
}

const receiveUpdatedPracticeRequestOnError = (state) => {
    return {
        ...state,
        sendingPracticeRequest: false,
        errorOnSendPracticeRequest: true
    }
}

////////////////////////////////////////////////////////////////

const reducer = ( state = initialState, action ) => {
    switch ( action.type ) {
        case actionTypes.LOAD_PRACTICE_REQUESTS: return loadPracticeRequests( state );
        case actionTypes.SET_PRACTICE_REQUESTS: return setPracticeRequests( state, action );

        case actionTypes.LOAD_PRACTICE_ENTERPRISES: return loadEnterprises( state );
        case actionTypes.SET_PRACTICE_ENTERPRISES: return setEnterprises( state, action );

        case actionTypes.SEND_PRACTICE_REQUEST: return sendPracticeRequest( state );
        case actionTypes.RECEIVE_PRACTICE_REQUEST_RESULT_ON_SUCCESS: return receivePracticeRequestResultOnSuccess( state, action );
        case actionTypes.RECEIVE_PRACTICE_REQUEST_RESULT_ON_ERROR: return receivePracticeRequestResultOnError( state );

        case actionTypes.UPDATE_PRACTICE_REQUEST: return updatePracticeRequest( state );
        case actionTypes.RECEIVE_UPDATED_PRACTICE_REQUEST_ON_SUCCESS: return receiveUpdatedPracticeRequestOnSuccess( state, action );
        case actionTypes.RECEIVE_UPDATED_PRACTICE_REQUEST_ON_ERROR: return receiveUpdatedPracticeRequestOnError( state );

        default: return state;
    }
};
export default reducer;